import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles/global.css';

// Create the app
const app = createApp(App);

// Use the router
app.use(router);

// Set the initial hole ID to be loaded in FormenBewerter view
app.config.globalProperties.$initialHoleId = 444;

// Mount the app
app.mount('#app');

// Signal that the app has been mounted, completing the loading animation
if (window.appMounted && typeof window.appMounted === 'function') {
  window.appMounted();
}

// Create or modify main.js (or your app entry file)
import { gsap } from 'gsap';
import { MorphSVGPlugin } from './services/MorphSVGPlugin'; // Adjust path as needed

// Register the plugin ONCE at the application startup
gsap.registerPlugin(MorphSVGPlugin);